import { AuthError, Configuration, PopupRequest, PublicClientApplication, SilentRequest } from "@azure/msal-browser";
import axios, { AxiosRequestConfig } from "axios";
import isString from "lodash/isString";
import some from "lodash/some";

import { checkLoggedInUser } from "../state/actions/authActions";
import store from "../store";
import { Permission } from "../utils/enums";
import { IUser } from "../utils/types/models";

let msalConfig: Configuration;

let _tenantId: string;
let _clientId: string;

let _authClientApplication: PublicClientApplication;

export function setAdCredentials(tenantId: string, clientId: string): void {
	_tenantId = tenantId;
	_clientId = clientId;
}

export function authContext(): PublicClientApplication {
	if (_authClientApplication) {
		return _authClientApplication;
	}

	const tenantId: string = _tenantId;
	const clientId: string = _clientId;

	msalConfig = {
		auth: {
			clientId,
			authority: `https://login.microsoftonline.com/${tenantId}`,
			redirectUri: window.location.origin
		},
		cache: {
			cacheLocation: "localStorage",
			storeAuthStateInCookie: false
		}
	};

	_authClientApplication = new PublicClientApplication(msalConfig);
	_authClientApplication.initialize();

	return _authClientApplication;
}

// tslint:disable-next-line: no-any
export async function fetch(requestOptions: AxiosRequestConfig, authNeeded: boolean): Promise<any> {
	if (!requestOptions.headers) {
		requestOptions.headers = {};
	}
	if (authNeeded) {
		const req: SilentRequest = {
			scopes: [`api://${msalConfig.auth.clientId}/Kovera.Api`],
			account: authContext().getActiveAccount()
		};
		let token: string;
		try {
			token = (await authContext().acquireTokenSilent(req)).accessToken;
		} catch (error) {
			if (
				error instanceof AuthError ||
				(typeof error === "object" &&
					"errorCode" in error &&
					isString(error.errorCode) &&
					(error.errorCode === "consent_required" || error.errorCode === "interaction_required" || error.errorCode === "login_required"))
			) {
				const popupRequest: PopupRequest = {
					scopes: req.scopes
				};

				try {
					token = (await authContext().acquireTokenPopup(popupRequest)).accessToken;
				} catch (error2) {
					clearUserCache();
					store.dispatch(checkLoggedInUser());
					// tslint:disable-next-line
					console.error(error2);
				}
			}
		}
		requestOptions.headers.Authorization = `Bearer ${token}`;
	}
	return axios(requestOptions);
}

export function clearUserCache(): void {
	authContext().clearCache({
		account: authContext().getActiveAccount()
	});
}

export function hasPermission(...permissions: Permission[]): boolean {
	const currentUser: IUser = store.getState().authenticationState.currentUser;

	if (!permissions || permissions.length <= 0) {
		return true;
	}

	if (currentUser) {
		return some(permissions, (permision: string) => {
			return currentUser.permissions[permision];
		});
	}

	return false;
}
